import { EventHelper } from "app/helpers/eventHelper";
import PopularEventCellIcons from "./components/PopularEventCellIcons/PopularEventCellIcons";
import PopularEventCellStats from "./components/PopularEventCellStats/PopularEventCellStats";
export const EventNameSectionTop = (
  props: Record<string, any>
): React.JSX.Element => {
  const {
    data,
    isEventInExtraTime,
    scoreFullTime,
    toggleAddRemoveToFavorites,
    isBeforeExtraTime,
    isFavourite,
  } = props;
  return (
    <div className="popular-event-cell__label__content__top">
      <PopularEventCellIcons
        data={data}
        isEventInExtraTime={isEventInExtraTime}
        scoreFullTime={scoreFullTime}
        isFavourite={isFavourite}
        toggleAddRemoveToFavorites={() => toggleAddRemoveToFavorites(data.id)}
        isBeforeExtraTime={isBeforeExtraTime}
      />
      {EventHelper.isEventLive(data) &&
        !EventHelper.isEventLiveWithNoScore(data) &&
        data.isActive && <PopularEventCellStats />}
    </div>
  );
};
